export default {
  pages: {
    root: {
      name: 'root',
      children: [
        '63e2565bf2f031001fb812a8',
        '63e2565bf2f031001fb812ac',
        '63e2565bf2f031001fb812b0',
        '63e2565bf2f031001fb812b4',
        '63e2565bf2f031001fb812bc'
      ],
      id: 'root',
      pageUrl: 'root'
    },
    '63e2565bf2f031001fb812a8': {
      id: '63e2565bf2f031001fb812a8',
      name: '404',
      pageUrl: '404'
    },
    '63e2565bf2f031001fb812ac': {
      id: '63e2565bf2f031001fb812ac',
      name: 'index',
      pageUrl: 'index',
      seo: {
        'og:description':
          'Comprehensive dyslexia screening and personalized support for reading and learning success.',
        title: 'Home | Gryfn Dyslexia Test',
        'og:title': 'Home | Gryfn Dyslexia Test',
        'og:image':
          'https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z',
        description:
          'Comprehensive dyslexia screening and personalized support for reading and learning success.'
      }
    },
    '63e2565bf2f031001fb812b0': {
      id: '63e2565bf2f031001fb812b0',
      pageUrl: 'about',
      name: 'About',
      seo: {
        'og:title': 'About | Gryfn Dyslexia Test',
        'og:description':
          'Comprehensive dyslexia screening and personalized support for reading and learning success.',
        description:
          'Comprehensive dyslexia screening and personalized support for reading and learning success.',
        'og:image':
          'https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z',
        title: 'About | Gryfn Dyslexia Test'
      }
    },
    '63e2565bf2f031001fb812b4': {
      id: '63e2565bf2f031001fb812b4',
      seo: {
        'og:image':
          'https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z',
        title: 'Work | Gryfn Dyslexia Test',
        'og:title': 'Work | Gryfn Dyslexia Test',
        description:
          'Comprehensive dyslexia screening and personalized support for reading and learning success.',
        'og:description':
          'Comprehensive dyslexia screening and personalized support for reading and learning success.'
      },
      pageUrl: 'work',
      name: 'Work'
    },
    '63e2565bf2f031001fb812bc': {
      id: '63e2565bf2f031001fb812bc',
      pageUrl: 'contact',
      name: 'Contact',
      seo: {
        'og:image':
          'https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z',
        title: 'Contact | Gryfn Dyslexia Test',
        'og:title': 'Contact | Gryfn Dyslexia Test',
        description:
          'Comprehensive dyslexia screening and personalized support for reading and learning success.',
        'og:description':
          'Comprehensive dyslexia screening and personalized support for reading and learning success.'
      }
    }
  },
  mode: 'production',
  projectType: 'create-react-app',
  site: {
    styles: {},
    seo: {}
  }
};
